import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import * as endpoints from "../../api/endpoints"
import * as PublicTransportationTypes from "./PublicTransportationTypes"
import { DateTime } from "luxon"
import * as date from "../../booking/helpers/date"
import { handleEvalTracking } from "../../helpers/tracking"

export class ItineraryDepartureList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      airlinesPageLink: props.airlinesPageLink,
      departures: [],
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)
  }

  async componentDidMount() {
    const dtLocale = date.luxonLocale(this.state.flightInfo.language)
    const zone = "Europe/Copenhagen"
    const estimatedPublicTime = DateTime.fromISO(this.state.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
    const adjustedTime = estimatedPublicTime.plus({ minutes: this.props.block.departureBufferTime }).toJSDate().toISOString()

    const trainData = {
      id: this.props.block?.trainStationDepartureId || "8603328",
      datetime: adjustedTime,
      tripOptions: 4 | 2,
    }
    const busData = {
      id: this.props.block?.busStationDepartureId || "000051935",
      datetime: adjustedTime,
      tripOptions: 1 | 4,
    }
    const metroData = {
      id: this.props.block?.metroStationDepartureId || "008600858",
      destId: this.state.block?.metroStationArrivalId || "8603307",
      datetime: adjustedTime,
      tripOptions: 1 | 2,
    }

    let departuresLists = []
    departuresLists = await Promise.all([this.getDepatureBoard(trainData), this.getDepatureBoard(busData), this.getMetroTrip(metroData)])
      .then((responses) => {
        return Promise.all(
          responses.map((response) => {
            return response
          }),
        )
      })
      .then((data) => {
        return data
      })
      .catch((err) => {
        console.log(err)
      })
    const departures = [].concat.apply([], departuresLists)
    this.setState({ departures: departures })
  }

  getDepatureBoard(data) {
    return endpoints
      .getRejseplanenDepartureBoard(data)
      .then((res) => {
        return res.data
      })
      .then((data) => {
        let departures = []
        if (data && data.Departure) {
          data.Departure.forEach((dep) => {
            departures.push(this.adjustDepartureData(dep))
          })
        }
        return departures
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getMetroTrip(data) {
    return endpoints
      .getRejseplanenTrip(data)
      .then((res) => {
        return res.data
      })
      .then((data) => {
        let departures = []
        if (data && data.Trip) {
          data.Trip.forEach((trip) => {
            departures.push(this.getDepartureFromMetroTrip(trip))
          })
        }
        return departures.slice(0, 2)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  adjustDepartureData = (departure) => {
    return {
      FinalStop: departure.FinalStop,
      Name: departure.Name.split(" ")[0],
      Time: departure.Time,
      Date: departure.Date,
      Type: departure.Type,
      Cancelled: departure.Cancelled || false,
    }
  }

  getDepartureFromMetroTrip = (trip) => {
    return {
      FinalStop: trip.Leg[0].Destination.Name,
      Name: trip.Leg[0].Name.split(" ")[1],
      Time: trip.Leg[0].Origin.Time,
      Date: trip.Leg[0].Origin.Date,
      Type: trip.Leg[0].Type,
      Cancelled: trip.Cancelled || false,
    }
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const hasContentBlocks = this.props.block.contentArea?.length > 0
    const newLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode
    const hasDepartureLists = this.props.block.departureListContentArea?.length > 0

    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }

    return (
      <div
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem ${theme ? theme : ""} foldable`}
      >
        <div
          className={"departure-info__essentials__detailitems__detailitem__header pointer"}
          onClick={(e) => this.showHideContent(e, ".contentWrapper")}
        >
          <h5>{this.props.block.heading || "Velkommen og på gensyn"}</h5>
          {this.props.block.subHeading ? <h6>{this.props.block.subHeading}</h6> : ""}
        </div>
        <div className={"contentWrapper show-hide"}>
          {this.props.block.text || this.props.block.buttonText ? (
            <div className={"textbuttoncontainer"}>
              {this.props.block.text ? <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></span> : ""}
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={this.props.block.linkToAirlineBool ? newLink : this.props.block.buttonLink}
                    onClick={() => handleEvalTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {hasDepartureLists
            ? this.props.block.departureListContentArea.map((block, index) => {
                return <DepartureList key={index} {...this.state} {...block} block={block} parentBlock={this.props.block} />
              })
            : ""}
          {hasContentBlocks ? this.renderContentBlocks(this.state.block.contentArea) : ""}
        </div>
      </div>
    )
  }
}

class DepartureList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      departures: props.departures,
      filteredDepartures: [],
    }
  }

  componentDidMount() {
    this.getFilteredDepartures()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.departures !== this.props.departures) {
      this.setState({ departures: this.props.departures }, () => {
        this.getFilteredDepartures()
      })
    }
  }

  getFilteredDepartures = () => {
    if (this.state.departures && this.state.departures.length > 0) {
      const exclusions = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.departureListTypeExclusions, true)
      if (exclusions && exclusions.length > 0) {
        let filteredDepartures = []
        filteredDepartures = this.state.departures.filter((d) => {
          if (d) {
            let include = true
            exclusions.forEach((ex) => {
              switch (ex.value) {
                case "Tog":
                  if (
                    d.Type === PublicTransportationTypes.TRAIN_REG ||
                    d.Type === PublicTransportationTypes.TRAIN_IC ||
                    d.Type === PublicTransportationTypes.TRAIN_LYN ||
                    d.Type === PublicTransportationTypes.TRAIN_S ||
                    d.Type === PublicTransportationTypes.TRAIN_TOG
                  ) {
                    include = false
                  }
                  break
                case "Bus":
                  if (
                    d.Type === PublicTransportationTypes.BUS ||
                    d.Type === PublicTransportationTypes.BUS_EXB ||
                    d.Type === PublicTransportationTypes.BUS_NB ||
                    d.Type === PublicTransportationTypes.BUS_TB
                  ) {
                    include = false
                  }
                  break
                case "Metro":
                  if (d.Type === PublicTransportationTypes.METRO) {
                    include = false
                  }
                  break
              }
            })
            return include
          }
          return false
        })
        this.setState({ filteredDepartures: filteredDepartures })
      } else {
        this.setState({ filteredDepartures: this.state.departures })
      }
    }
  }

  getTimeUntilDeparture = (minutes) => {
    let timeUntil
    if (minutes > 60) {
      timeUntil = this.timeConvert(minutes)
    } else {
      timeUntil = this.props.parentBlock.minutesBeforeDepartureLabel?.replace("{minutes}", minutes) || `${minutes} min`
    }
    return timeUntil
  }

  timeConvert(n) {
    var num = n
    var hours = num / 60
    var rhours = Math.floor(hours)
    var minutes = (hours - rhours) * 60
    var rminutes = Math.floor(minutes)
    const hoursLabel = this.props.parentBlock.hoursBeforeDepartureLabel?.replace("{hours}", rhours) || `${rhours}t`
    const minutesLabel = this.props.parentBlock.minutesBeforeDepartureLabel?.replace("{minutes}", rminutes) || `${rminutes} min`
    return `${hoursLabel} ${minutesLabel}`
  }

  getMinutes = (departure) => {
    const dateArr = departure.Date.split(".")
    const timeArr = departure.Time.split(":")

    let depatureDateTime = new Date()
    depatureDateTime.setFullYear(20 + dateArr[2], dateArr[1] - 1, dateArr[0])
    depatureDateTime.setHours(timeArr[0])
    depatureDateTime.setMinutes(timeArr[1])

    const dtLocale = date.luxonLocale(this.props.flightInfo.language)
    const zone = "Europe/Copenhagen"
    const departureTime = DateTime.fromJSDate(depatureDateTime).setZone(zone, { keepLocalTime: true })
    const estimatedPublicTime = DateTime.fromISO(this.props.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)

    const duration = departureTime.diff(estimatedPublicTime, ["minutes"]).toObject()
    const minutes = Math.floor(duration.minutes)
    return minutes
  }

  render() {
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)

    let departures = this.state.filteredDepartures
    if (this.props.block.maxDeparturesShown) {
      departures = departures.slice(0, this.props.block.maxDeparturesShown)
    }

    return (
      <div className="departure-info__essentials__detailitems__detailitem__infobox__departures">
        {this.props.block.text ? (
          <div
            className="departure-info__essentials__detailitems__detailitem__infobox__departures__desc"
            dangerouslySetInnerHTML={{ __html: this.props.block.text }}
          ></div>
        ) : (
          ""
        )}
        {departures.length > 2 ? (
          <div className="departure-info__essentials__detailitems__detailitem__infobox__departures__train">
            <ul>
              {departures.map((dep, index) => {
                if (dep) {
                  const mins = this.getMinutes(dep)
                  if (mins < 0) return ""
                  const timeUntil = this.getTimeUntilDeparture(mins)
                  return (
                    <li key={index}>
                      <span className="text--truncate">
                        ({dep.Name}) {this.props.parentBlock?.towardsLabel || "Mod"} {dep.FinalStop}
                      </span>
                      {dep.Cancelled ? (
                        <span className={`train-dep-min`}>
                          {this.props.parentBlock?.cancelledLabel || "(Aflyst)"} <span className={`strikethrough`}>{timeUntil}</span>
                        </span>
                      ) : (
                        <span className={`train-dep-min`}>{timeUntil}</span>
                      )}
                    </li>
                  )
                }
                return ""
              })}
            </ul>
          </div>
        ) : departures.length > 0 ? (
          departures.map((dep, index) => {
            if (dep) {
              const mins = this.getMinutes(dep)
              if (mins < 0) return ""
              const timeUntil = this.getTimeUntilDeparture(mins)
              return (
                <div key={index} className="departure-info__essentials__detailitems__detailitem__infobox__departures__metro">
                  <span className="text--truncate">
                    ({dep.Name}) {this.props.parentBlock?.towardsLabel || "Mod"} {dep.FinalStop}
                  </span>
                  {dep.Cancelled ? (
                    <span className={`train-dep-min`}>
                      {this.props.parentBlock?.cancelledLabel || "(Aflyst)"} <span className={`strikethrough`}>{timeUntil}</span>
                    </span>
                  ) : (
                    <span className={`train-dep-min`}>{timeUntil}</span>
                  )}
                </div>
              )
            }
            return ""
          })
        ) : (
          ""
        )}
        <div className="departure-info__essentials__detailitems__detailitem__infobox__departures__metro__desc">
          {this.props.block.ticketText ? this.props.block.ticketText : ""}
          {this.props.block.buttonText && this.props.block.buttonLink ? (
            <div className="cta-button">
              <a
                className={`button button--small button--general rm-this-class rm-this-class-hide-default ${buttonColor ? buttonColor : "casc-blue"}`}
                href={this.props.block.buttonLink}
              >
                <span className="text">{this.props.block.buttonText}</span>
              </a>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    )
  }
}
